module.exports = __webpack_public_path__ + "img/play.4c5bf0c7.svg";